import TruncateMarkup from "react-truncate-markup";
import {
    StyledDetails,
    TitleTypography,
    StyledTruncteContainer,
    StyledDateContainer,
    StyledTruncatedScheduling
} from "./StyledComponents";
import {KmsTypeRelatedMediaEntry} from "../types";
import { Tooltip } from "@kaltura/ds-react-components";
import { ChevronRight16Icon } from "@kaltura/ds-react-icons";

interface DetailsProps extends Pick<KmsTypeRelatedMediaEntry, 'name'> {
    startDay?: string | number;
    endDay?: string | number;
    startTime?: string | number;
    endTime?: string | number;
}

/**
 * related media item details section
 */
const Details = (props: DetailsProps) => {

    const {name, startDay, endDay, startTime, endTime} = props;

    const showSchedule = startDay !== 0 && endDay !== 0 && startTime !== 0 && endTime !== 0;

    return (
        <StyledDetails className={"kms-ds-media-page-sidebar-related-media-item-details"}>
            <Tooltip title={name} placement="top">
                <StyledTruncteContainer className={"kms-ds-media-page-sidebar-related-media-item-title chromatic-ignore"}>
                    <TruncateMarkup lines={2} >
                        <TitleTypography variant={"body1Highlight"}>
                            {name}
                        </TitleTypography>
                    </TruncateMarkup>
                </StyledTruncteContainer>
            </Tooltip>

            {showSchedule && <div className={"kms-ds-media-page-sidebar-related-media-item-schedule"}>
                <Tooltip title={<Scheduling {...props}/>} placement="top">
                    <StyledTruncatedScheduling variant={"body2Highlight"}>
                        <Scheduling {...props}/>
                    </StyledTruncatedScheduling>
                </Tooltip>
            </div>}
        </StyledDetails>
    )
}

export default Details

const Scheduling = ({startDay, startTime, endDay, endTime}: DetailsProps) => {
    return <>
        {startDay === endDay && (
            <>
                <div>{startDay}</div>
                <div>{startTime} - {endTime}</div>
            </>
        )}

        {startDay !== endDay && (
            <>
                <StyledDateContainer>
                    <div>{startDay}, {startTime}</div>
                    <ChevronRight16Icon />
                </StyledDateContainer>
                <div>{endDay}, {endTime}</div>
            </>
        )}
    </>
};
